import { css } from 'styled-components';
import token from 'styled-token';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';
import { sizeMixin } from '../sizeMixin';
import { ChipMixin } from './ChipMixin';

/** @class FilterChipMixin */
/** @method */
export var FilterChipMixin = function FilterChipMixin(props) {
  return token({
    borderWidth: "Chip.borderWidth",
    fontType: "Chip.fontType",
    height: "Chip.height",
    pressedBackgroundColorHover: "Chip.pressed.backgroundColorHover",
    pressedBorderWidth: 'Chip.pressed.borderWidth',
    pressedHorizontalSpacing: 'Chip.pressed.horizontalSpacing'
  }, function (_ref) {
    var borderWidth = _ref.borderWidth,
      fontType = _ref.fontType,
      height = _ref.height,
      pressedBackgroundColorHover = _ref.pressedBackgroundColorHover,
      pressedBorderWidth = _ref.pressedBorderWidth,
      pressedHorizontalSpacing = _ref.pressedHorizontalSpacing;
    return css(["", " &[aria-pressed='true'][aria-pressed='true']{padding-right:", "px;padding-left:", "px;", " &:not(:active){", ";}}", ""], ChipMixin(props), pressedHorizontalSpacing, pressedHorizontalSpacing, sizeMixin({
      fontType: fontType,
      borderWidth: pressedBorderWidth * 2,
      size: height
    })(props), hoverMediaQueryMixin("background-color: " + pressedBackgroundColorHover + ";"), sizeMixin({
      fontType: fontType,
      borderWidth: borderWidth * 2,
      size: height
    })(props));
  })(props);
};